import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ccl-form-item',
    templateUrl: './form-item.component.html',
    styleUrls: ['./form-item.component.css']
})
export class FormItemComponent {
    @Input()
    label = '';

    @Input()
    labelFlex: number = 30;
}
